import type { QueryFunction } from '@tanstack/react-query';
import { getNews } from '@simplywallst/services';

export const QUERY_KEY = ['RELATED_NEWS'] as const;

export const queryFn: QueryFunction<
  Awaited<ReturnType<typeof getNews>>['data'],
  [string, string]
> = async (context) => {
  const { 1: companyId } = context.queryKey;
  const response = await getNews(companyId);
  return response.data;
};
